(() => {
  'use strict';

  const SELECTOR = '[data-product-similar-slider="true"]';

  const VISIBLE_CARDS = 4;
  const TRANSITION_DURATION = 360;
  const SWIPE_THRESHOLD = 35;

  function initSlider(root) {
    if (!root || root.dataset.sliderReady === 'true') return;

    const viewport = root.querySelector(
      '.product-similar__viewport'
    );

    const track = root.querySelector(
      '.product-similar__track'
    );

    const nextButton = root.querySelector(
      '.product-similar__next'
    );

    const prevButton = root.querySelector(
      '.product-similar__prev'
    );

    if (
      !viewport ||
      !track ||
      track.children.length <= VISIBLE_CARDS
    ) {
      return;
    }

    root.dataset.sliderReady = 'true';

    /*
      Normal autoplay:
      Default fallback = 3 seconds
    */
    const autoplayDelay =
      Number(root.dataset.autoplay) || 3000;

    /*
      Resume after user interaction:
      Default fallback = 2 seconds
    */
    const resumeDelay =
      Number(root.dataset.resumeDelay) || 2000;

    let timer = null;

    let isVisible = false;
    let isAnimating = false;

    let pointerStartX = null;
    let pointerStartY = null;

    let suppressClick = false;


    /* =========================
       TIMER
    ========================= */

    function clearTimer() {
      if (timer) {
        window.clearTimeout(timer);
        timer = null;
      }
    }


    function scheduleNext(delay = autoplayDelay) {
      clearTimer();

      if (!isVisible || document.hidden) {
        return;
      }

      timer = window.setTimeout(() => {
        moveNext(true);
      }, delay);
    }


    /* =========================
       CARD WIDTH
    ========================= */

    function getStep() {
      const firstCard = track.firstElementChild;

      if (!firstCard) return 0;

      const trackStyle =
        window.getComputedStyle(track);

      const gap =
        parseFloat(
          trackStyle.columnGap ||
          trackStyle.gap ||
          '0'
        ) || 0;

      return (
        firstCard.getBoundingClientRect().width +
        gap
      );
    }


    /* =========================
       RESET TRACK
    ========================= */

    function resetTrack() {
      track.style.transition = 'none';

      track.style.transform =
        'translate3d(0,0,0)';

      /*
        Force browser to apply reset
        before next transition.
      */
      void track.offsetWidth;

      track.style.transition = '';
    }


    /* =========================
       NEXT
    ========================= */

    function finishNext(
      firstCard,
      fromAutoplay
    ) {
      if (!isAnimating) return;

      /*
        Move first product to end.

        A B C D E F
        becomes
        B C D E F A
      */
      track.appendChild(firstCard);

      resetTrack();

      isAnimating = false;

      /*
        After automatic movement,
        continue normal 3-sec cycle.
      */
      if (fromAutoplay) {
        scheduleNext(autoplayDelay);
      }
    }


    function moveNext(
      fromAutoplay = false
    ) {
      if (
        isAnimating ||
        track.children.length <= VISIBLE_CARDS
      ) {
        return;
      }

      clearTimer();

      const step = getStep();

      const firstCard =
        track.firstElementChild;

      if (!step || !firstCard) {
        scheduleNext(autoplayDelay);
        return;
      }

      isAnimating = true;

      track.style.transition =
        `transform ${TRANSITION_DURATION}ms ease`;

      track.style.transform =
        `translate3d(-${step}px,0,0)`;


      const complete = () => {
        finishNext(
          firstCard,
          fromAutoplay
        );
      };


      track.addEventListener(
        'transitionend',
        complete,
        {
          once: true
        }
      );


      /*
        Fallback in case transitionend
        does not fire.
      */
      window.setTimeout(() => {
        if (isAnimating) {
          finishNext(
            firstCard,
            fromAutoplay
          );
        }
      }, TRANSITION_DURATION + 120);
    }


    /* =========================
       PREVIOUS
    ========================= */

    function finishPrevious() {
      if (!isAnimating) return;

      isAnimating = false;

      track.style.transition = '';
    }


    function movePrevious() {
      if (
        isAnimating ||
        track.children.length <= VISIBLE_CARDS
      ) {
        return;
      }

      clearTimer();

      const lastCard =
        track.lastElementChild;

      if (!lastCard) return;

      const step = getStep();

      if (!step) return;


      /*
        Move last card to front.
      */
      track.insertBefore(
        lastCard,
        track.firstElementChild
      );


      track.style.transition = 'none';

      track.style.transform =
        `translate3d(-${step}px,0,0)`;


      void track.offsetWidth;


      isAnimating = true;


      track.style.transition =
        `transform ${TRANSITION_DURATION}ms ease`;

      track.style.transform =
        'translate3d(0,0,0)';


      track.addEventListener(
        'transitionend',
        finishPrevious,
        {
          once: true
        }
      );


      window.setTimeout(() => {
        if (isAnimating) {
          finishPrevious();
        }
      }, TRANSITION_DURATION + 120);
    }


    /* =========================
       USER INTERACTION
    ========================= */

    function pauseForInteraction() {
  clearTimer();

  timer = window.setTimeout(() => {
    /*
      Customer has been inactive for 2 seconds.
      Autoplay is now allowed again.

      Do NOT slide immediately.
      Start the normal 3-second autoplay interval.
    */
    scheduleNext(autoplayDelay);
        }, resumeDelay);
    }


    function manualNext() {
      /*
        User click:
        move immediately.
      */
      moveNext(false);

      /*
        Then automatic movement resumes
        after 2 seconds.
      */
      pauseForInteraction();
    }


    function manualPrevious() {
      movePrevious();

      pauseForInteraction();    }


    /* =========================
       ARROW BUTTONS
    ========================= */

    if (nextButton) {
      nextButton.addEventListener(
        'click',
        () => {
          manualNext();
        }
      );
    }


    if (prevButton) {
      prevButton.addEventListener(
        'click',
        () => {
          manualPrevious();
        }
      );
    }


    /* =========================
       HOVER / POINTER
    ========================= */

    viewport.addEventListener(
      'pointerenter',
      () => {
        /*
          Pause current timer,
          but resume after 2 sec
          even if pointer remains here.
        */
        pauseForInteraction();
      }
    );


    /* =========================
       SWIPE START
    ========================= */

    viewport.addEventListener(
      'pointerdown',
      (event) => {
        pointerStartX = event.clientX;
        pointerStartY = event.clientY;

        clearTimer();
      }
    );


    /* =========================
       SWIPE END
    ========================= */

    viewport.addEventListener(
      'pointerup',
      (event) => {

        if (
          pointerStartX === null ||
          pointerStartY === null
        ) {
          pauseForInteraction();
          return;
        }


        const deltaX =
          event.clientX - pointerStartX;

        const deltaY =
          event.clientY - pointerStartY;


        pointerStartX = null;
        pointerStartY = null;


        /*
          Horizontal swipe only.
        */
        if (
          Math.abs(deltaX) >
            SWIPE_THRESHOLD &&
          Math.abs(deltaX) >
            Math.abs(deltaY)
        ) {

          suppressClick = true;


          if (deltaX < 0) {
            moveNext(false);
          } else {
            movePrevious();
          }


          /*
            Prevent accidental product
            navigation after swipe.
          */
          window.setTimeout(() => {
            suppressClick = false;
          }, 300);
        }


        /*
          Resume automatically
          after 2 seconds.
        */
        pauseForInteraction();      }
    );


    viewport.addEventListener(
      'pointercancel',
      () => {

        pointerStartX = null;
        pointerStartY = null;

        pauseForInteraction();      }
    );


    /* =========================
       PREVENT ACCIDENTAL CLICK
       AFTER SWIPE
    ========================= */

    viewport.addEventListener(
      'click',
      (event) => {

        if (!suppressClick) return;

        event.preventDefault();
        event.stopPropagation();

      },
      true
    );


    /* =========================
       KEYBOARD / FOCUS
    ========================= */

    root.addEventListener(
      'focusin',
      () => {
        pauseForInteraction();
      }
    );


    root.addEventListener(
      'focusout',
      () => {
        pauseForInteraction();      }
    );


    /* =========================
       VIEWPORT PERFORMANCE
    ========================= */

    const observer =
      new IntersectionObserver(
        (entries) => {

          entries.forEach(
            (entry) => {

              isVisible =
                entry.isIntersecting;


              if (isVisible) {

                /*
                  First automatic movement
                  after normal 3 sec.
                */
                scheduleNext(
                  autoplayDelay
                );

              } else {

                /*
                  Don't animate when section
                  is outside viewport.
                */
                clearTimer();
              }

            }
          );

        },
        {
          threshold: 0.15
        }
      );


    observer.observe(root);


    /* =========================
       TAB VISIBILITY
    ========================= */

    document.addEventListener(
      'visibilitychange',
      () => {

        if (document.hidden) {

          clearTimer();

        } else if (isVisible) {

          scheduleNext(
            autoplayDelay
          );
        }

      }
    );
  }


  /* =========================
     INITIALISE
  ========================= */

  function initializeAll(
    scope = document
  ) {

    if (
      scope.matches &&
      scope.matches(SELECTOR)
    ) {
      initSlider(scope);
    }


    scope
      .querySelectorAll(SELECTOR)
      .forEach(initSlider);
  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      () => {
        initializeAll();
      }
    );

  } else {

    initializeAll();
  }


  /*
    Shopify Theme Editor support.
  */
  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initializeAll(event.target);
    }
  );

})();